import DateUtils from '../../inumet_js_lib/utils/dateUtils'
import TypesUtils from '../../inumet_js_lib/utils/typesUtils'

const COLOR_SERIE_1 = '#90caf9'
const COLOR_SERIE_2 = '#1e88e5'

const COLORES_FONDO = ['#e0e0e0', '#fff']

//const PADDING_VALUE_CHART_PERCENT = 20

function getOpciones(
    height,
    Highcharts,
    fechaInicio,
    horasPronostico,
    resolucionTemporalParaMostrar,
    resolucionTemporalReal,
    serie1,
    serie2,
    serieDir,
    nombresSeries,
    unidades,
    tiposGraficas,
    maxsMinsEjeY
) {
    const fechaFin = DateUtils.addHours(fechaInicio, horasPronostico)

    let plotBands = []
    /*
    
    {
                        from: Date.UTC(2024, 2, 15),
                        to: Date.UTC(2024, 2, 16),
                        color: '#EFFFFF',
                    },
                    {
                        from: Date.UTC(2024, 2, 16),
                        to: Date.UTC(2024, 2, 17),
                        color: '#FFFFEF',
                        label: {
                            text: '<em>Offices:</em><br> Tomtebu',
                            style: {
                                color: '#999999',
                            },
                            y: 30,
                        },
                    },
    
    */

    let diaIni = fechaInicio.clone().startOf('day')
    let i = 0
    while (diaIni < fechaFin) {
        plotBands.push({
            from: diaIni.toDate(),
            to: diaIni.clone().endOf('day').toDate(),
            color: COLORES_FONDO[i % 2],
        })
        diaIni = DateUtils.addDays(diaIni, 1)
        i++
    }

    let optionsChart = {
        chart: {
            marginBottom: serieDir ? 120 : 70,
            marginRight: 10,
            marginTop: 40,
            plotBorderWidth: 1,
            height,
            alignTicks: false,
            scrollablePlotArea: {
                minWidth: 720,
            },
        },

        title: {
            useHTML: true,
            text: undefined,

            align: 'left',
            style: {
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
            },
        },

        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 500,
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom',
                        },
                    },
                },
            ],
        },

        tooltip: {
            shared: false,
            useHTML: true,
            headerFormat:
                '<small>{point.x:%a %e, %H:%M} ' +
                '<b>{point.point.symbolName}</b><br>',
            formatter() {
                let indexSerie = nombresSeries.indexOf(this.series.name)

                if (indexSerie !== 2) {
                    return (
                        `<p><b>${DateUtils.latinDT(this.key)}</b></p><table>` +
                        `<tr><td style="color: ${this.series.color}">${this.series.name}: </td>` +
                        `<td style="text-align: right"><b>${
                            this.y +
                            ' ' +
                            (unidades && unidades.length > indexSerie
                                ? unidades[indexSerie]
                                : '')
                        }</b></td> ` +
                        (serieDir && serieDir.length > this.point.index
                            ? `<tr><td style="color: ${this.series.color}">Dir: </td>` +
                              `<td style="text-align: left"><b>` +
                              `${getDirVientoPtosCardinalesStr(
                                  serieDir[this.point.index]
                              )} </tr>`
                            : '')
                    )
                } else {
                    return (
                        `<p><b>${DateUtils.latinDT(this.key)}</b></p><table>` +
                        `<tr><td style="color: ${this.series.color}">${this.series.name}: </td>` +
                        `<td style="text-align: right"><b>
                            ${
                                getDirVientoPtosCardinalesStr(
                                    this.point.direction
                                ) + ' '
                            }</b></td></tr>`
                    )
                }
            },
        },
        time: {
            useUTC: true,
        },

        xAxis: [
            {
                // Bottom X axis
                type: 'datetime',
                tickInterval: resolucionTemporalParaMostrar * 36e5,
                minorTickInterval: resolucionTemporalReal * 36e5,
                tickLength: 2,
                gridLineWidth: 1,
                gridLineColor: 'rgba(128, 128, 128, 0.1)',
                alignTicks: true,
                minPadding: 0,
                maxPadding: 0,
                offset: serieDir ? 50 : 0,
                showLastLabel: false,
                labels: {
                    format: '{value:%H}',
                },
                crosshair: true,

                plotBands,
            },
            {
                // Top X axis
                linkedTo: 0,
                type: 'datetime',
                showLastLabel: false,
                tickInterval: 12 * 36e5,
                labels: {
                    format: '{value: <span style="font-size: 12px; font-weight: bold">%a %e %Hh</span> }',
                    align: 'left',
                    x: 3,
                    y: 8,
                },
                opposite: true,
                tickLength: 3,
            },
        ],

        yAxis: [
            {
                title: {
                    text: null,
                },
                labels: {
                    format: '{value}' + (unidades ? unidades[0] : ''),
                    style: {
                        fontSize: '10px',
                    },
                    x: -3,
                },
                max: maxsMinsEjeY ? maxsMinsEjeY.max : undefined,
                min: maxsMinsEjeY ? maxsMinsEjeY.min : undefined,

                plotLines: [
                    {
                        // zero plane
                        value: 0,
                        color: '#5c6bc0',
                        width: 1,
                        zIndex: 2,
                    },
                ],
                maxPadding: 0.3,

                gridLineColor: 'rgba(128, 128, 128, 0.1)',
            },
        ],

        legend: {
            enabled: false,
        },

        series: [
            {
                name: nombresSeries ? nombresSeries[0] : '',
                data: getSeriePorHora(
                    serie1,
                    fechaInicio,
                    fechaFin,
                    resolucionTemporalReal
                ),
                type: tiposGraficas ? tiposGraficas[0] : 'area',
                marker: {
                    enabled: false,
                    states: {
                        hover: {
                            enabled: true,
                        },
                    },
                },

                zIndex: 1,
                // El color 2 es mas oscuro y queda mejor si tenemos una serie sola.
                // Si son dos series el contraste queda mejor con la segunda serie con el color mas oscuro
                color: serie2 ? COLOR_SERIE_1 : COLOR_SERIE_2,
                negativeColor: '#48AFE8',
                showInLegend: true,
            },
            {
                name: nombresSeries && serie2 ? nombresSeries[1] : '',
                data: getSeriePorHora(
                    serie2,
                    fechaInicio,
                    fechaFin,
                    resolucionTemporalReal
                ),
                type:
                    tiposGraficas && tiposGraficas.length > 1
                        ? tiposGraficas[1]
                        : 'area',
                marker: {
                    enabled: false,
                    states: {
                        hover: {
                            enabled: true,
                        },
                    },
                },
                showInLegend: true,
                zIndex: 0,
                color: COLOR_SERIE_2,
                negativeColor: '#48AFE8',
            },
        ],
    }
    if (serieDir) {
        optionsChart.series.push({
            name: nombresSeries && serieDir ? nombresSeries[2] : '',
            type: 'windbarb',

            color: Highcharts.getOptions().colors[1],
            data: getSeriePorHora(
                serie1,
                fechaInicio,
                fechaFin,
                resolucionTemporalReal,
                serieDir
            ),

            showInLegend: false,
        })
    }
    return optionsChart
}

function getSeriePorHora(
    serie,
    fechaInicio,
    fechaFin,
    resolucionTemporal,
    serieDir
) {
    let res = []
    if (TypesUtils.notUndefOrNull(serie)) {
        let fecha = fechaInicio.valueOf()

        let i = 0
        while (
            DateUtils.compareDates(fecha, fechaFin) <= 0 &&
            i < serie.length
        ) {
            let item = serie[i]
            let obj = {
                x: fecha,
            }
            if (serieDir) {
                obj.direction = serieDir[i]
                obj.value = 1
            } else {
                obj.y = item
            }
            res.push(obj)
            fecha = DateUtils.addHours(fecha, resolucionTemporal).valueOf()
            i++
        }
    }
    return res
}

function getDirVientoPtosCardinalesStr(dirViento) {
    if (!TypesUtils.isNumber(dirViento)) {
        if (dirViento === 'variable' || dirViento === 'calmo') return dirViento
        dirViento = parseFloat(dirViento)
    }
    let dirVientoCorr
    if (dirViento >= 348.75) {
        dirVientoCorr = dirViento + 11.25 - 360
    } else {
        dirVientoCorr = dirViento + 11.25
    }
    let strViento
    if (dirVientoCorr <= 22.5) {
        strViento = 'N'
    } else if (dirVientoCorr <= 45) {
        strViento = 'NNE'
    } else if (dirVientoCorr <= 67.5) {
        strViento = 'NE'
    } else if (dirVientoCorr <= 90) {
        strViento = 'ENE'
    } else if (dirVientoCorr <= 112.5) {
        strViento = 'E'
    } else if (dirVientoCorr <= 135) {
        strViento = 'ESE'
    } else if (dirVientoCorr <= 157.5) {
        strViento = 'SE'
    } else if (dirVientoCorr <= 180) {
        strViento = 'SSE'
    } else if (dirVientoCorr <= 202.5) {
        strViento = 'S'
    } else if (dirVientoCorr <= 225) {
        strViento = 'SSW'
    } else if (dirVientoCorr <= 247.5) {
        strViento = 'SW'
    } else if (dirVientoCorr <= 270) {
        strViento = 'WSW'
    } else if (dirVientoCorr <= 292.5) {
        strViento = 'W'
    } else if (dirVientoCorr <= 315) {
        strViento = 'WNW'
    } else if (dirVientoCorr <= 337.5) {
        strViento = 'NW'
    } else if (dirVientoCorr <= 360) {
        strViento = 'NNW'
    }
    return strViento
}

export { getOpciones }
